import type { AuthContext } from "@veiligh/reporting-core/adapters";
import type { UserDashboard } from "@veiligh/reporting-core/domain";

/**
 * Web app implementation of AuthContext
 * Uses the existing Redux state for user information and permissions
 */
export class WebReportingAuth implements AuthContext {
  constructor(
    getUser: () => {
      id: string;
      name: string;
      email?: string;
      accessLevel?: string;
    },
    getPermissions: () => string[],
  ) {
    this.getUser = getUser;
    this.getPermissions = getPermissions;
  }

  getUser: () => {
    id: string;
    name: string;
    email?: string;
    accessLevel?: string;
  };
  getPermissions: () => string[];

  get user() {
    return this.getUser();
  }

  get permissions() {
    return this.getPermissions();
  }

  hasPermission(permission: string): boolean {
    return this.permissions.includes(permission);
  }

  canEditDashboard(dashboard: UserDashboard): boolean {
    // User can edit if they own the dashboard or have admin permissions
    const isOwner = dashboard.ownerId === this.user.id;
    const isAdmin = this.hasPermission("admin");
    return isOwner || isAdmin;
  }

  canDeleteDashboard(dashboard: UserDashboard): boolean {
    // User can delete if they own the dashboard or have admin permissions
    const isOwner = dashboard.ownerId === this.user.id;
    const isAdmin = this.hasPermission("admin");
    return isOwner || isAdmin;
  }
}
